(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('vue')) :
	typeof define === 'function' && define.amd ? define(['vue'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.app = factory(global.vue));
})(this, (function (vue) { 'use strict';

	let preRoute = null;
	function loadScript(url) {
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = url;

			script.onload = resolve;
			script.onerror = reject;

			document.head.appendChild(script);
		});
	}

	var main = {
		// Vue3和文档有区别
		async install(Vue, app, { router, platformId, apiUrl }) {
			// let api = process.env.NODE_ENV === 'development' ? 'https://t1-static-local.52rental.com/page-common/' : 'https://page.52rental.com/page-common/'
			let src = `${apiUrl}analysis/vue-track.js?` + new Date().getTime();

			await loadScript(src);


			let _lxzlTrack = window && window._lxzlTrack;

			Vue.mixin({
				watch: {
					'$route'(to, form) {
						if (to.path !== preRoute || !preRoute) {
							console.log('.......页面切换........');
							_lxzlTrack.clear();
							_lxzlTrack.init({
								platformId,
								cur_refer: to.path,
							});
							preRoute = to.path;
						}
					},
				},
				mounted() {
					this.$nextTick(() => {
						_lxzlTrack.updateTrack(this);
					});
				}
			});

			app.config.globalProperties.$rentalTrack = _lxzlTrack;

			if (router) {
				await router.isReady();

				vue.nextTick(() => {
					_lxzlTrack.init({
						platformId,
						cur_refer: router.options.history.state.current,
					});
					// 当前页面实例 Vue._container._vnode
					_lxzlTrack.updateTrack(Vue._container._vnode);
				});

			}
		}
	};

	return main;

}));
